<template>
    <div class="p-3">
        <h3>RL 3.7 Kegiatan Pelayanan Neonatal</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Neonatal" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-neonatal',
                layout: 'fitDataStretch',
                groupBy: 'kelompok',
                groupHeader: function (value, count, data) {
                    return value.toUpperCase();
                },
                columnMinWidth: 80,
                columns: [
                    {
                        title: "Jenis Kegiatan",
                        field: "kategori",
                        width: 250,
                        frozen: true,
                    },
                    {
                        title: "Jumlah Rujukan",
                        field: "jml_rujukan",
                        width: 250,
                        frozen: false,
                    },
                    {
                        title: "Jumlah Non Rujukan",
                        field: "jml_non_rujukan",
                        width: 250,
                        frozen: false,
                    },
                    {
                        title: "Total",
                        field: "jml_pasien",
                        width: 250,
                        frozen: false,
                    },
                    // {
                    //     title: "Rujukan Medis",
                    //     columns: [
                    //         {
                    //             title: "Rumah Sakit",
                    //             field: "medis_rs",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Puskesmas Lainnya",
                    //             field: "medis_puskesmas",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Fas Kes Lainnya",
                    //             field: "medis_faslain",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Jumlah Hidup",
                    //             field: "medis_hidup",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Jumlah Mati",
                    //             field: "medis_mati",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Total",
                    //             field: "medis_total",
                    //             hozAlign: "center",
                    //         }
                    //     ]
                    // },
                    // {
                    //     title: "Rujukan Non Medis",
                    //     columns: [
                    //         {
                    //             title: "Jumlah Hidup",
                    //             field: "nonmedis_hidup",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Jumlah Mati",
                    //             field: "nonmedis_mati",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Total",
                    //             field: "nonmedis_total",
                    //             hozAlign: "center",
                    //         }
                    //     ]
                    // },
                    // {
                    //     title: "Non Rujukan",
                    //     columns: [
                    //         {
                    //             title: "Jumlah Hidup",
                    //             field: "nonrujukan_hidup",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Jumlah Mati",
                    //             field: "nonrujukan_mati",
                    //             hozAlign: "center",
                    //         },
                    //         {
                    //             title: "Total",
                    //             field: "nonrujukan_total",
                    //             hozAlign: "center",
                    //         }
                    //     ]
                    // }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
